<template>
  <div class="downLoad">
    <!-- 标题 -->
    <div class="downLoadTitle clearFloat">
      <i class="downLoadTitlePic"></i>
      <h3 class="downLoadTitleText" style="width:80%">通知公告</h3>
      <hr style="color:#ccc" />
    </div>
    <ul class="downContent">
      <li class="downloadList clearFloat" v-for="item in listData" :key="item.id">
        <span class="downLoadTitle" v-cloak>{{item.title}}</span>
        <span class="downLoadNum" v-cloak>{{item.down_fqty}}次</span>
        <span class="updataTime" v-cloak>{{item.created_at}}</span>
        <el-button class="downLoadBtn" @click="downLoadBtn(item.id)">立即下载</el-button>
      </li>
    </ul>
    <div>
      <div class="detail_title">
        <h3 class="h3_sty">{{indexNum.title}}</h3>
        <span class="detail_date">{{indexNum.created_t}}</span>
      </div>
      <div v-html="indexNum.content" style="width:90%;margin-left:10%;text-align: left;"></div>
      <div class="content-row">
        <!-- <span @click="return_index" style="font-size:13px ;color:#409EFF">>>返回</span> -->
        <!-- <el-button @click="return_index">>>返回</el-button> -->
        <span
          @click="return_index"
          class="pointer"
          style="font-size:14px ;color:#409EFF;position: fixed;bottom: 4%;"
        ><<返回</span>
        <!-- <el-button
          @click="return_index"
          type="primary"
          icon="el-icon-back"
          circle
          style="position: fixed;bottom: 4%;"
        ></el-button>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    indexNum: Object
  },
  data() {
    return {
      value: "",
      listData: [], //获取的数据
      // 分页
      page: 1,
      total: 0,
      pageSize: 10
    };
  },

  mounted() {
    this.view();
  },

  methods: {
    // 获取数据
    view() {
    },
    return_index() {
      this.$parent.notice();
    }
  }
};
</script>

<style lang="less" scoped>
.detail_title {
  display: flex;
  justify-content: space-between;
  padding-bottom: 2%;
}
.h3_sty {
  display: inline-block;
  margin: 0px;
}
.detail_date {
  margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Customized/components/notice/detail.vue